export const DELETE_USER_SESSION_V1_URI = '/DeleteUserSession.v1';
export const VirtualPaymentGlobalContext = 'virtualPaymentGlobalContext';
